import { useState } from 'react';
import './ForgetPassword.scss';
import { useNavigate } from 'react-router-dom';
import { svgs } from '../../common/assats';
import { useTranslation } from 'react-i18next';
import TextInputWithIcon from '../../components/TextInputWithIcon';
import Button from '../../components/Button';
import { ValidationError } from 'yup';
import { forgetPasswordSchema } from '../../common/consts/yupSchems';
import { forgetPassword } from '../../common/api/apiCalls';
import { useAlert } from '../../common/contexts/AlertContext';

function ForgetPassword() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [errors, setErrors] = useState<{ email?: string[]}>({});
    const [email, setEmail] = useState('');
      const alert = useAlert();
    

    const getText = (text: string) => t(`forgetPassword.${text}`);
    
    async function validate() {
        try {
            await forgetPasswordSchema.validate({ email }, { abortEarly: false });
            setErrors({});
            return true;
        } catch (err: any) {
            if (err instanceof ValidationError) {
                const validationErrors: { email?: string[] } = { email: [] };
                err.inner.forEach((error: any) => {
                    const path = error.path as keyof typeof validationErrors;
                    if (path && validationErrors[path]) {
                        validationErrors[path]?.push(error.message);
                    }
                });
                setErrors(validationErrors);
            } else {
                console.error("Unexpected validation error:", err);
            }
            return false;
        }
    }
    
    async function verfiy() {
        if (await validate()) {
            try{
                const res = await forgetPassword(email);
                if (res?.success) {
                    navigate("/ResetPasswordOTP", { state: { email, otpType: "resetPassword" } });
                } else {
                    alert("Cannot send email", "error");
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    

    return (
        <div onKeyDown={(e) => { if (e.key === 'Enter') verfiy() }} className='login-main-container flex-center'>
            <div className='login-content'>
                <svgs.logos.Logo className='logo' />
                <div className="input-wrapper">
                    <h3 className='headline'> {getText("forgot_password")}</h3>
                    <p className='text'>{getText("enter_the_email_associated_with_your_account")}</p>
                    <TextInputWithIcon
                        errors={errors}
                        label={getText("Email")}
                        Icon={svgs.logos.Mail}
                        placeholder={getText('Enter_your_email')}
                        setValue={setEmail}
                        value={email}
                        inputName="email"
                        filedCorrect={Boolean(errors?.email && !email.length) ? false : undefined}
                    />
                </div>
                <Button onClick={verfiy} text={getText("verfiy")} />
                <button onClick={() => navigate('/')} className="back-to-login">
                    {getText("back_to_login")}
                </button>
            </div>
        </div>


    );
}
export default ForgetPassword;
